"use client";
import { createTheme, ThemeOptions } from "@mui/material/styles";
import { breakpointsOptions } from "./options/breakpoints";
import { paletteOptions } from "./options/palette";
import { spacingOptions } from "./options/spacing";
import { transitionOptions } from "./options/transition";
import { typographyOptions } from "./options/typography";
import { components } from "./options/components";

export const themeOptions: ThemeOptions = {
  breakpoints: breakpointsOptions,
  palette: paletteOptions,
  spacing: spacingOptions,
  transitions: transitionOptions,
  typography: typographyOptions,
  components,
};
export const theme = createTheme(themeOptions);
